import { default as _91_46_46_46slug_93TbX57ymoQ6Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/[...slug].vue?macro=true";
import { default as indexyMRKqX6vtKMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/auth/index.vue?macro=true";
import { default as indexCF3lDE5hzdMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93sLKSaYKInnMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93JO4dSJMl9tMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93C9m0iBsHQFMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93EBlKuVvnH5Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/news/[slug].vue?macro=true";
import { default as organisationsewikRK7BPNMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsLN3JgbWNNTMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programshg76TvM2V8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexSfCvxph1pJMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index.vue?macro=true";
import { default as dungeonsjd5UDTZS8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsASJpFPGIhPMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexZqPqD54jnRMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index.vue?macro=true";
import { default as indexmkO08fVfwEMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatapuVicD9oeaMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassRtG3NWItV1Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93yVOrJYDoUpMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexGtCWWWjuZMMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataiBL6hS0FLaMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsKytnZxIpIAMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsXDNczJ1JSMMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights2AxJJXcNLbMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93L58CTOIshNMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index8LGhIQlpK9Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivities04tP9qzCoFMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatalcDVdJgxXsMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_937hBmRGgkm6Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexeotTntrfdBMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivities3yu8t8i1yHMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatamqSGu0CNCRMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93uLgCwhYyDqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexWimGTM5UWJMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataqlS1ZFB5xdMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93unWZo7BfUHMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexa4DQV23iYWMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataCQ9gPzjTTKMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassqAYPAkxPPdMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormstjAQXZsCiAMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93emawB1TnygMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexrzGjWf1QY7Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesbtaeC8TK5rMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseData0bj2gOpOO3Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriods5DURuw3UwtMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as statisticSurveyRightsk8xLldutf1Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue?macro=true";
import { default as _91id_93syW5nCVKWUMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as index5umIuTcvcaMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesJ4ShfvDa1oMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataompuYilzFTMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsvbYpsHp8mzMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93isxDp9gsXqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexHX7aHDk6PYMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataIj6VcUrXYiMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataYa2IJzSibDMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93dfRa4hmQk3Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index3NYu6LuNmLMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatak1ndmtl4jlMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93zcTZ9l8PhAMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexOJiqcetD8qMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroups5nFyM9RCfZMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataPhCmdsONN4Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93iekNQHZABdMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexY3C45CytwqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishestqoGTQIlvqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesHtU7J4xgCBMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsqp2ZXhdYwRMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDatawn6aWzeDmWMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiastvkQIfGjmiMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesvZAHIZuFFRMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93z3swjogxRtMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexXrpGG7Yn5LMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsQc9JUURFixMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltoKkDlwZZFhMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDatacAW96w0ZGlMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsFKaKFkSn7FMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93Iw5WEIYucKMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexscN0XduzW6Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsuyRcFPcFzbMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesCam2a2VuCDMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataLcQvJJpeD5Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93WnZTvAX4YrMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id].vue?macro=true";
import { default as indexslGaPQVmbCMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovaloQBQwmfrfqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93gmgN1vJDlaMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexKHsWWPQUQQMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersuE19dTnLseMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesb0hKNaE3cqMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingslDPXJnuFyRMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataWhsoP6nXsNMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories5GDnuFKJGMMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptjibolDytO5Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementyV82S5sTKgMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersF8xVLowhfsMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93jB5UvM2KKyMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexpdNcOrDABpMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsfetGRkp75LMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesGTfwk4hTH0Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatavxjGMCMhR8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersXjooEBQR7HMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureArn9lWZaRHMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93PXfrLTaWd8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexZ15m1rT3CTMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersQxv5oKQqQSMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users.vue?macro=true";
import { default as settingsxhEhsJCW2DMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesahY2nI7jABMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataxdbeApH7B8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_938u4sgec92MMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexgz6aFq3HEFMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as servicex7IBj5k3bzMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service.vue?macro=true";
import { default as languagepSRQ7cs8pGMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataQnrVhUUplMMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories342Vy3UanzMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementBYFHp6QRXbMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers0idOfK9FwsMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93eP5w08SKw1Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatao5g18bkTx7Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureaxlaQ97pjVMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93JH5LgbE3bMMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id].vue?macro=true";
import { default as indexadqLQImQZSMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/index.vue?macro=true";
import { default as settingsEbR8DnQki4Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings.vue?macro=true";
import { default as signatureyMIms5h3fCMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/signature.vue?macro=true";
import { default as sportbizzSEK2yxnlFLMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93aigLYFfhHzMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93EMRzYWD8p0Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexPql8fc54R8Meta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93kC3EZ5UE2wMeta } from "/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93TbX57ymoQ6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexyMRKqX6vtKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexCF3lDE5hzdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93sLKSaYKInnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93JO4dSJMl9tMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93C9m0iBsHQFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsewikRK7BPNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexSfCvxph1pJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicex7IBj5k3bzMeta?.name,
    path: "/service",
    meta: servicex7IBj5k3bzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatak1ndmtl4jlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexmkO08fVfwEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93yVOrJYDoUpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexGtCWWWjuZMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93L58CTOIshNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index8LGhIQlpK9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_937hBmRGgkm6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexeotTntrfdBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93uLgCwhYyDqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexWimGTM5UWJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93unWZo7BfUHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexa4DQV23iYWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93emawB1TnygMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexrzGjWf1QY7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93syW5nCVKWUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyRights",
    path: "statisticSurveyRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: index5umIuTcvcaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93isxDp9gsXqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsvbYpsHp8mzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexHX7aHDk6PYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93dfRa4hmQk3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index3NYu6LuNmLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93zcTZ9l8PhAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishestqoGTQIlvqMeta?.name,
    path: "parishes",
    meta: parishestqoGTQIlvqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93iekNQHZABdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsQc9JUURFixMeta?.name,
    path: "regions",
    meta: regionsQc9JUURFixMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93z3swjogxRtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsuyRcFPcFzbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93Iw5WEIYucKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexscN0XduzW6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93WnZTvAX4YrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexslGaPQVmbCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovaloQBQwmfrfqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsxhEhsJCW2DMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersuE19dTnLseMeta?.name,
    path: "loginProviders",
    meta: loginProvidersuE19dTnLseMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93gmgN1vJDlaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexKHsWWPQUQQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsfetGRkp75LMeta?.name,
    path: "organisations",
    meta: organisationsfetGRkp75LMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93jB5UvM2KKyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexpdNcOrDABpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersQxv5oKQqQSMeta?.name,
    path: "users",
    meta: usersQxv5oKQqQSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93PXfrLTaWd8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexZ15m1rT3CTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_938u4sgec92MMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexgz6aFq3HEFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsEbR8DnQki4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93eP5w08SKw1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93JH5LgbE3bMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexadqLQImQZSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureyMIms5h3fCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzSEK2yxnlFLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93aigLYFfhHzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93EMRzYWD8p0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexPql8fc54R8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93kC3EZ5UE2wMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250717141555/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]